import React, { useEffect, useState } from "react";
import NavBar from "../components/common/NavBar";
import Footer from "../components/common/Footer";
import TopImage from "../components/common/TopImage";

const baseURL = process.env.PUBLIC_URL + "/assets/Faculty";

function FacultyCard({ faculty }) {
  const imageUrl = `${baseURL}/${faculty.image}`;

  return (
    <div className="mb-8 flex flex-col bg-admission-color items-center pb-7 w-full sm:w-[45%] md:w-[30%] lg:w-[20%] mx-2 text-xs font-medium tracking-normal leading-4 text-black whitespace-nowrap rounded-lg border border-solid border-stone-300 hover:shadow-lg transition">
      <div className="w-full h-[300px] overflow-hidden rounded-t-lg bg-gray-100">
        <img
          loading="lazy"
          src={imageUrl}
          className="w-full h-full object-cover object-top"
          alt={faculty.altText}
        />
      </div>
      <div className="mt-4 text-base font-bold text-center">{faculty.name}</div>
      <div className="mt-1.5 text-center">{faculty.designation}</div>
      <div className="mt-5 text-center">{faculty.qualification}</div>
    </div>
  );
}

function FacultyList({ facultyList }) {
  return (
    <div className="flex flex-wrap justify-center gap-4">
      {facultyList.map((faculty, index) => (
        <FacultyCard key={index} faculty={faculty} />
      ))}
    </div>
  );
}

function Faculty() {
  const [facultyList, setFacultyList] = useState([]);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/facultyList.json`)
      .then((res) => res.json())
      .then((data) => setFacultyList(data))
      .catch((err) => console.error("Error loading faculty list:", err));
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <TopImage text="Our Faculty" />
      <main className="flex-grow mt-20 mx-28 mb-10 max-md:mx-5 max-md:my-8">
        {facultyList.length > 0 ? (
          <FacultyList facultyList={facultyList} />
        ) : (
          <p className="text-center text-gray-500">Loading faculty data...</p>
        )}
      </main>
      <Footer />
    </div>
  );
}

export default Faculty;
